import { TenantDto } from '@admin/app/api'
import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

type Props = {
  options: TenantDto[]
  onChange: (tenant: TenantDto) => void
} & TomAutoCompleteProps<TenantDto, false>

export const TenantsAutoComplete = observer((props: Props) => {
  const { t } = useTranslate()
  const { dataCy, defaultValue, label, onChange, options } = props

  return (
    <TomAutoComplete
      {...props}
      dataCy={dataCy ?? 'tenants-autocomplete'}
      label={label ?? t('tenant', 'Tenant')}
      options={options}
      defaultValue={defaultValue}
      entityKey='id'
      enablePortal
      placeholder={t('selectTenant', 'Select tenant')}
      onChangeEntity={entity => {
        onChange(entity as TenantDto)
      }}
    />
  )
})
